export default function ImpressumPage() {
  return <main className="page legal-page" data-testid="impressum-page">
    <h1 data-testid="impressum-title">Impressum</h1>
    <section className="legal-card" data-testid="impressum-content">
      <p><strong>Dosa Industrietechnik</strong><br />Lessingstraße 11<br />77966 Kappel-Grafenhausen<br />Deutschland</p>
      <p>E-Mail: <a href="mailto:info@dosa-industrietechnik.de">info@dosa-industrietechnik.de</a></p>
      <p>Umsatzsteuer-Identifikationsnummer: DE312872953</p>
      <p>Vertretungsberechtigte Gesellschafter: Domenik Sattler</p>
      <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer">https://ec.europa.eu/consumers/odr</a>.</p>
      <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
      <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
    </section>
  </main>;
}